import { ProductCategory } from "src/enum/ProductEnum";
import {
  fetchCategories,
  fetchCategoryProduct,
  fetchProductByCategoryAndSortOption,
  fetchShopAllProductsBySortOptions,
} from "src/services/CategoryApi";
import { fetchCategoryProductsByDropdown, fetchProductsByCategory } from "src/services/ProductApi";

export const loadCategories = async (setCategories) => {
  try {
    const data = await fetchCategories();
    const formattedCategories = data.map((cat) => ({      
      imageUrl: cat.image,
      name: cat.category,
    }));
    setCategories(formattedCategories);
  } catch (error) {
    console.error("Failed to fetch categories:", error);
  }
};

export const fetchAndSetProductByCategoryName = async (
  category,
  setCategoryProducts,
  setLoading
) => {
  setLoading(true);
  const fetchedProducts = await fetchCategoryProduct(category);
  setCategoryProducts(fetchedProducts);
};

export const sortCategoryProductByDropDown = async (
  category,
  sortOption,
  setCategoryProducts,
  setLoading,
  searchParams
) => {
  setLoading(true);
  const minPrice = searchParams?.get("minPrice");
  const maxPrice = searchParams?.get("maxPrice");
  const inStock = searchParams?.get("inStock") === "true";
  const outOfStock = searchParams?.get("outOfStock") === "true";
  const categories = searchParams?.getAll("category");
  const fetchedProducts = await fetchProductByCategoryAndSortOption(
    category,
    sortOption,
    minPrice,
    maxPrice,
    inStock,
    outOfStock,
    categories
  );

  setCategoryProducts(fetchedProducts);
  setLoading(false);
};

export const shopAllProductByDropDown = async (sortOption, setLoading, searchParams, setShopAllProducts) => {
  setLoading(true);
  let payload = {};
  if (sortOption === "dsc") {
    payload["sortbydate"] = "desc";
  } else {
    payload["sortbyprice"] = sortOption;
  }

  // Add price range filters if they exist in URL params
  const minPrice = searchParams.get("minPrice");
  const maxPrice = searchParams.get("maxPrice");
  if (minPrice) {
    payload["minPrice"] = parseInt(minPrice);
  }
  if (maxPrice) {
    payload["maxPrice"] = parseInt(maxPrice);
  }

  // Add instock filter if available
  const inStock = searchParams.get("inStock");
  const outOfStock = searchParams.get("outOfStock");
  
  if (inStock === "true") {
    payload["instock"] = true;
  } else if (outOfStock === "true") {
    payload["instock"] = false;
  }

   // Add category filter if available
   const categories = searchParams.getAll("category");
   if (categories && categories.length > 0) {
     payload["categories"] = categories;
   }

  const products = await fetchShopAllProductsBySortOptions(payload);
  setShopAllProducts(products || []);

  setLoading(false);
};

export const fetchAndSetAllProductsByProductCategory = async (
  productcategoryName,
  setCategoryProducts,
  setLoading
) => {
  setLoading(true);
  let productCategory = ProductCategory.Trending;
  if (productcategoryName === "NewArrivals") {
    productCategory = ProductCategory.NewArrival;
  } else if (productcategoryName === "BestSellers") {
    productCategory = ProductCategory.BestSeller;
  }
  const fetchedProducts = await fetchProductsByCategory(productCategory, 1000);
  setCategoryProducts(fetchedProducts);
  setLoading(false);
};

export const fetchSortedCategoryProducts = async (
  productcategoryName,
  setCategoryProducts,
  sortOption,
  setLoading,
  searchParams
) => {
  setLoading(true);
  let productCategory = ProductCategory.Trending;
  if (productcategoryName === "NewArrivals") {
    productCategory = ProductCategory.NewArrival;
  } else if (productcategoryName === "BestSellers") {
    productCategory = ProductCategory.BestSeller;
  }
  const minPrice = searchParams?.get("minPrice");
  const maxPrice = searchParams?.get("maxPrice");
  const inStock = searchParams?.get("inStock") === "true";
  const outOfStock = searchParams?.get("outOfStock") === "true";
  const categories = searchParams?.getAll("category");

  const fetchedProducts = await fetchCategoryProductsByDropdown(productCategory, sortOption, minPrice, maxPrice, inStock, outOfStock, categories);
  setCategoryProducts(fetchedProducts);
  setLoading(false);
};

